import { render } from "./confirmation-approval-reject-client.vue?vue&type=template&id=fde0a33e&ts=true"
import script from "./confirmation-approval-reject-client.vue?vue&type=script&lang=ts"
export * from "./confirmation-approval-reject-client.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__